import { render } from "./teachResearchMenu.vue?vue&type=template&id=578ee19e&scoped=true"
import script from "./teachResearchMenu.vue?vue&type=script&lang=js"
export * from "./teachResearchMenu.vue?vue&type=script&lang=js"

import "./teachResearchMenu.vue?vue&type=style&index=0&id=578ee19e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578ee19e"]])

export default __exports__